var map = {
	"./phone-en/EN_1.jpg": 7466,
	"./phone-en/EN_2.jpg": 7627,
	"./phone-en/EN_3.jpg": 5092,
	"./phone-en/EN_4.jpg": 4109,
	"./phone-en/EN_5.jpg": 2877,
	"./phone-en/EN_6.jpg": 9197,
	"./phone-en/EN_7.jpg": 5206,
	"./phone-en/EN_8.jpg": 9553,
	"./phone-en/swipe1.jpg": 1431,
	"./phone-en/swipe3.jpg": 2067,
	"./phone-en/swipe4.jpg": 9475,
	"./phone-ms/MAS_1.jpg": 5524,
	"./phone-ms/MAS_2.jpg": 757,
	"./phone-ms/MAS_3.jpg": 6337,
	"./phone-ms/MAS_4.jpg": 1058,
	"./phone-ms/MAS_5.jpg": 4782,
	"./phone-ms/MAS_6.jpg": 3416,
	"./phone-ms/MAS_7.jpg": 7461,
	"./phone-ms/MAS_8.jpg": 155,
	"./phone-ms/swipe1.jpg": 379,
	"./phone-ms/swipe3.jpg": 5952,
	"./phone-ms/swipe4.jpg": 7090,
	"./phone-tw/ZH_1.jpg": 6533,
	"./phone-tw/ZH_2.jpg": 7955,
	"./phone-tw/ZH_3.jpg": 6640,
	"./phone-tw/ZH_4.jpg": 2175,
	"./phone-tw/ZH_5.jpg": 9349,
	"./phone-tw/ZH_6.jpg": 5562,
	"./phone-tw/ZH_7.jpg": 2349,
	"./phone-tw/ZH_8.jpg": 567,
	"./phone-tw/swipe1.jpg": 8297,
	"./phone-tw/swipe3.jpg": 7153,
	"./phone-tw/swipe4.jpg": 2466,
	"./phone-zh/ZH_1.jpg": 8736,
	"./phone-zh/ZH_2.jpg": 4528,
	"./phone-zh/ZH_3.jpg": 8093,
	"./phone-zh/ZH_4.jpg": 792,
	"./phone-zh/ZH_5.jpg": 6423,
	"./phone-zh/ZH_6.jpg": 1993,
	"./phone-zh/ZH_7.jpg": 7050,
	"./phone-zh/ZH_8.jpg": 2745,
	"./phone-zh/swipe1.jpg": 923,
	"./phone-zh/swipe3.jpg": 6878,
	"./phone-zh/swipe4.jpg": 5710
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5826;